import * as React from 'react'
// components
import { ReduxEntitySelect } from 'components/FormElements'
// graphql
import { USERS_OR_POSITIONS_QUERY } from 'graphql/user/queries'
// constants
import { ENTITIES } from 'constants/entities'
import { SELECT_GROUP_LABELS } from 'constants/forms'
// types
import { IOption } from 'components/FormElements/Select'
// utils
import get from 'lodash/get'
import { required } from 'utils/validators'
import { getMemberOrPositionLabel } from 'utils/systemProcess'

interface Props {
  name: string
  label: string
  fieldOptions: (IOption & any)[]
}

const ApproverSelect: React.FC<Props> = ({ name, label, fieldOptions }) => {
  const getOptions = (res) => {
    const options = get(res, 'data.usersOrPositions.data', []).map((item) => ({
      label: getMemberOrPositionLabel(item),
      value: item.id,
      entity: Object.hasOwn(item, 'userId') ? ENTITIES.POSITION : ENTITIES.USER
    }))

    return [{ label: 'Users and Positions', options }]
  }

  const prepareOptions = (options: IOption[]) => [
    { label: SELECT_GROUP_LABELS.FIELDS, options: fieldOptions },
    ...options
  ]

  const handleSearch = ({ search, refetch }) => refetch({ filter: { search } })

  return (
    <ReduxEntitySelect
      isMultiple
      name={name}
      label={label}
      validate={[required]}
      menuPortalTarget={null}
      getOptions={getOptions}
      handleSearch={handleSearch}
      prepareOptions={prepareOptions}
      query={USERS_OR_POSITIONS_QUERY}
    />
  )
}

export default ApproverSelect
